import styled from 'styled-components'
import {defaultTheme} from "../../styles/themes/default";

const statuses = {
    danger: {color: defaultTheme.red},
    warning: {color: defaultTheme.yellow},
    success: {color: defaultTheme.green},
    normal: {color: defaultTheme.gray}
}

interface TextAreaContainerProps {
    status: 'danger' | 'warning' | 'success' | 'normal'
}

export const TextAreaContainer = styled.div<TextAreaContainerProps>`
  width: 100%;

  p {
    color: ${({theme}) => theme.gray};
    font-size: 12px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    letter-spacing: 0.3px;
    text-transform: uppercase;
    margin-bottom: 2px;
  }

  small {
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    letter-spacing: 0.1px;
    text-align: left;
    margin-top: 10px;
    color: ${({status}: TextAreaContainerProps) => statuses[status].color};
  }

  textarea {
    padding: 20px;
    width: 100%;
    height: 120px;
    border-radius: 8px;
    border: 1px solid ${({status}: TextAreaContainerProps) => statuses[status].color};
    background: ${({theme}) => theme.grayExtraLight};
    color: ${({theme}) => theme.grayDark};
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    letter-spacing: 0.3px;

    ::placeholder {
      color: ${({theme}) => theme.gray};
      opacity: 0.4;
    }

    :focus {
      border-color: ${({status}: TextAreaContainerProps) => status === 'normal' ? defaultTheme.accent : statuses[status].color};
    }

    :disabled {
      border: unset;
      background: ${({theme}) => theme.grayLightest};
      opacity: 0.4;
    }
  }
`
